import React from 'react';
import { Platform, useWindowDimensions, View } from 'react-native';
import styled from 'styled-components/native';

import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';

import Button from '../../components/Button';
import { B, H1, P } from '../../components/Typography';
import Colors from '../../constants/Colors';

const StyledScrollView = styled.ScrollView.attrs(() => ({
  scrollIndicatorInsets: { right: 1 },
  contentContainerStyle: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
}))`
  background: ${Colors.primaryPurple};
`;

const StyledImageBackground = styled.ImageBackground<{ isDesktop: boolean }>`
  position: absolute;
  left: ${p =>
    p.isDesktop ? -250 : () => (Platform.OS === 'web' ? -200 : -250)}px;
  z-index: -1;
  width: ${p =>
    p.isDesktop
      ? () => (Platform.OS === 'android' || Platform.OS === 'ios' ? 150 : 110)
      : () => (Platform.OS === 'web' ? 140 : 258)}%;
  height: ${p =>
    Platform.OS === 'web' ? (p.isDesktop ? 100 : 84) : p.isDesktop ? 100 : 77}%;
`;

const StyledHeroView = styled.View<{ isDesktop: boolean }>`
  padding: ${p =>
    Platform.OS === 'web'
      ? p.isDesktop
        ? '293px 175px 200px 175px'
        : '210px 150px 225px 16px'
      : p.isDesktop
      ? '30% 175px 50% 85px'
      : '129px 20px 20% 16px'};
`;

const StyledButton = styled(Button)<{ isDesktop: boolean }>`
  margin-top: ${p => (p.isDesktop ? (Platform.OS === 'web' ? 15 : 40) : 25)}px;
  width: 170px;
`;

const StyledH1 = styled(H1)<{ isDesktop: boolean }>`
  font-size: ${p => (p.isDesktop ? 70 : 54)}px;
  margin-right: ${p => (p.isDesktop ? 0 : 75)}px;
  margin-bottom: ${p => (p.isDesktop ? 5 : 0)}px;
  padding-top: ${p => (p.isDesktop ? 10 : 0)}px;
  line-height: 55.86px;
  min-width: ${p => (p.isDesktop ? 295 : 260)}px;
`;

const StyledP = styled(P)`
  font-size: 28px;
  line-height: 32.8px;
  letter-spacing: -0.16px;
  margin: 15px 0 15px 0;
  max-width: 604px;
`;

const StudyGeneratorIntroScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= (Platform.OS === 'web' ? 1044 : 768);
  const navigation = useNavigation<StackNavigationProp<any>>();

  return (
    <StyledScrollView scrollIndicatorInsets={{ right: 1 }}>
      <StyledImageBackground
        isDesktop={isDesktop}
        resizeMode='stretch'
        source={require('../../assets/study-generator/abstract-background-4.png')}
      />
      <View>
        <StyledHeroView isDesktop={isDesktop}>
          <StyledH1 isDesktop={isDesktop} color='light'>
            Study Generator
          </StyledH1>
          <StyledP color='light'>Ready to begin your self-discovery?</StyledP>
          <StyledButton
            outlined
            inverse
            isDesktop={isDesktop}
            onPress={() => {
              navigation.push('FormTemplate', {
                formTemplateName: 'Start Study'
              });
            }}
          >
            Get Started
          </StyledButton>
        </StyledHeroView>
      </View>
    </StyledScrollView>
  );
};

export default StudyGeneratorIntroScreen;
